import { getDataFromLocalStorage } from "helpers/generalHelper";
import { isPricerRowActive } from "helpers/Pricer/activeStatus";
import { PRICER_NODES_COLORS } from "./pricerTable";

/** Match Team Run inactive row text (light theme). */
export const PRICER_INACTIVE_FONT_COLOR = "grey";

export const rowHeight = () => 27;
export const headerHeight = 32;

//! Please Note That Common Style Not Invoked In Pricer Since It Effects In Selected Rows
export const commonStyle =  {
  backgroundColor : 'var(--color-black-1)'
};

export const LightThemeStyle =  {
  fontSize        : 'var(--font-size-10)',
  backgroundColor : 'transparent'
};



export const isDisable = (params,pricerTablesDataWithRowDisable) => {
  const summaryId = params.data && params.data.summary_id? params.data.summary_id:params.node.aggData?.summary_id;
  const isDisable = pricerTablesDataWithRowDisable?.find(data => data.summary_id === summaryId)?.isDisable;
  return isDisable
};



const isExpiredValue = (value) => value === 1 || value === true || value === "1";

const getIsExpiredFromRowData = (data) => {
  if (!data) return false;
  const value =
    data.is_expired ?? data.summary_agg?.is_expired ?? data.leg_agg?.is_expired;
  return isExpiredValue(value);
};

export const isOptionExpired = (params) => {
  const node = params?.node;
  if (!node) return false;

  const rowData = node.group ? node.aggData : node.data;
  if (getIsExpiredFromRowData(rowData)) return true;

  if (node.group && Array.isArray(node.allLeafChildren)) {
    for (let i = 0; i < node.allLeafChildren.length; i += 1) {
      if (getIsExpiredFromRowData(node.allLeafChildren[i]?.data)) {
        return true;
      }
    }
  }

  return false;
};

export const EXPIRED_TITLE_COLOR = "var(--color-red-3)";

/** Red shorthand/title only — keeps inactive grey on other Team Run columns. */
export const applyExpiredTitleCellColor = (params, cellStyle = {}) => {
  if (params.colDef?.field !== "title" || !isOptionExpired(params)) {
    return cellStyle;
  }
  return { ...cellStyle, color: EXPIRED_TITLE_COLOR };
};

export const getRowClass = (params) => {
  const nodeData = params.node.group ? params.node.aggData : params.node.data;
  const rowType = nodeData?.row_type;
  const level = params.node.level;
  let rowClass = "getRowClass: no-specified-class";
  // if level 0 then row is summar-row
  // if level 1 and row_type is 2 then row is summar-row
  // if level 2 then row is subleg-row
  if (level === 0) {
    rowClass = "summary-row";
  } else if ((level === 1 && rowType === 2) || level === 2) {
    rowClass = "subleg-row";
  } else if (level === 1) {
    rowClass = "leg-row";
  }

  return isOptionExpired(params) ? `${rowClass} expired-row` : rowClass;
};


export const getRowStyle = (params,pricerTablesDataWithRowDisable)=>{
  const disableRow=isDisable(params, pricerTablesDataWithRowDisable);
  if(isOptionExpired(params)) {
    return { color: 'var(--color-red-3)' };
  }
  if(disableRow){
    return {color:'var(--color-gray-2)', pointerEvents: 'none'}
  }
  const rowData = params.node.group ? params.node.aggData : params.node.data;
  if (!isPricerRowActive(rowData)) {
    return { color: PRICER_INACTIVE_FONT_COLOR };
  }
  const nodesColorsArr =   getDataFromLocalStorage(PRICER_NODES_COLORS);

  if (nodesColorsArr) {
    const nodesArray = nodesColorsArr.map((item) => {
      let selectedColorObject = null;
      COLORS.map(obj => {
        if(obj.name === item.row_color) {
          selectedColorObject = obj;
          return obj;
        }
      })
      return Object.assign({}, item, selectedColorObject);
    })
    const colorStyle = nodesArray.filter((i) => i.summary_id === Number(rowData?.summary_id)).map((i) => i.color)
    return { color: colorStyle };
  }
}


export const COLORS = [
  { key:"1", name:'Green',        color:'var(--color-green-2)' },
  { key:"2", name:'Yellow',       color:'var(--color-yellow-2)' },
  { key:"3", name:'Magenta',      color:'var(--color-magenta-1)' },
  { key:"3", name:'remove_color', color:'' }
]